import React, { PureComponent } from 'react';
import withVisibility from '../hocs/with_visibility';

const { FeatureGuard, Booters } = window;

class Cashout extends PureComponent {
  componentDidMount() {
    FeatureGuard.guard('cashout', () => {
      Promise.all([FeatureGuard.guard('partial_cashout'), Booters.bootCashout()])
        .then(([partial]) => { window.cashoutApp.boot({ partial }); });
    });
  }

  render() {
    return <div id="cashout-container" />;
  }
}

export default withVisibility('cashout')(Cashout);
